var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCareemPlusBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 56,
    viewBox: "0 0 60 56",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5413_6624)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M-17.1253 15.3154L-9.87124 14.5594L-13.5474 4.70448L-4.67193 -6.37123L20.5596 -9L26.8879 7.96275C27.4361 9.43207 29.0861 10.5009 30.567 10.3467L47.6579 8.56604L57 33.6074L48.1246 44.6832L40.869 45.4391L44.5458 55.2955L35.6704 66.3712L10.4389 69L4.11063 52.0373C3.56238 50.5679 1.91311 49.4976 0.432983 49.6518L-16.6579 51.4325L-26 26.3911L-17.1253 15.3154Z",
    fill: "#00E784"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5413_6624"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -20,
    width: 80,
    height: 56,
    rx: 8,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCareemPlusBg);
export default __webpack_public_path__ + "static/media/careem-plus-bg.3d1e905b24793414396aab72b087db3f.svg";
export { ForwardRef as ReactComponent };